module.exports = __webpack_public_path__ + "img/figure1-offer.0430b088.png";